import Navigation from '@pelckmans/elementis/components/navigation';
import MenuIcon from '@pelckmans/elementis/icons/menu';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useClickOutside from '../../../../hooks/useClickOutside';
import PageNavigation from '../../page-level/PageNavigation';

function Menu() {
  const [showNavigation, setShowNavigation] = useState(false);
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  function togglePageNavigation() {
    setShowNavigation(!showNavigation);
  }

  useClickOutside({
    ref,
    elementId: 'page-navigation',
    onClickOutside: () => setShowNavigation(false),
    enabled: showNavigation,
  });

  return (
    <div ref={ref} className="page-level-menu">
      <Navigation>
        <Navigation.List>
          <li role="none">
            <button
              role="menuitem"
              onClick={togglePageNavigation}
              className={classNames('menu-navigation-item', { active: showNavigation })}
            >
              <MenuIcon
                size="lg"
                focusable={false}
                aria-hidden="true"
                className="menu-navigation-item-icon"
                data-testid="menu-icon"
              />
              <span className="menu-navigation-item-content">{t('PAGE_LEVEL.APPLICATION_NAVIGATION.MENU')}</span>
            </button>
          </li>
        </Navigation.List>
      </Navigation>
      {showNavigation && <PageNavigation onClick={() => setShowNavigation(false)} />}
    </div>
  );
}

export default Menu;
